import { render, staticRenderFns } from "./claimResponsibilityConfirmDetail.vue?vue&type=template&id=736352e4&scoped=true"
import script from "./claimResponsibilityConfirmDetail.vue?vue&type=script&lang=js"
export * from "./claimResponsibilityConfirmDetail.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/qualityStyle.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./claimResponsibilityConfirmDetail.vue?vue&type=style&index=1&id=736352e4&prod&lang=scss&scoped=true"
import style2 from "./claimResponsibilityConfirmDetail.vue?vue&type=style&index=2&id=736352e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736352e4",
  null
  
)

export default component.exports